import { render } from "./CourseEditorItemSection.vue?vue&type=template&id=ba4c7dba&scoped=true&ts=true"
import script from "./CourseEditorItemSection.vue?vue&type=script&lang=ts"
export * from "./CourseEditorItemSection.vue?vue&type=script&lang=ts"

import "./CourseEditorItemSection.vue?vue&type=style&index=0&id=ba4c7dba&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba4c7dba"]])

export default __exports__